﻿import {useContext, useEffect, useState} from "react";
import {PermitsContext, PermitsState} from "../contexts/PermitsContext";

export function usePermits(): PermitsState {
	const store = useContext(PermitsContext);
	if (!store) {
		throw new Error('usePermits must be used within PermitsProvider');
	}

	const [selectedState, setSelectedState] = useState(store.getState());

	useEffect(() => {
		return store.subscribe(() => {
			setSelectedState(store.getState());
		});

	}, [store]);

	return selectedState;
}
